import { Modal, Button } from "antd";
import { activateFleetModelApi } from "api/fleetModel";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { IFleetModel } from "models/fleetModel";
import { useState } from "react";

interface IProp {
  open: boolean;
  fleetModel: IFleetModel;
  handleClose: () => void;
}

export default function ActivateModal({
  open,
  fleetModel,
  handleClose,
}: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadFleetModels } = useDataLoadingContext();

  const handleActivate = async () => {
    setLoading(true);
    const { data, error } = await activateFleetModelApi(fleetModel.id);
    if (data) {
      showSuccess("FleetModel activated successfully");
      loadFleetModels();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to activate {fleetModel.name}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleActivate} loading={loading} type="primary">
            Activate
          </Button>
        </div>
      </div>
    </Modal>
  );
}
